<template>
  <div class="c_lp_image_text_tabs">
    <Tabs :tabs="tabs" identifier="index" :active-identifier="activeTabIndex" @onClickTab="setTab" />
    <div
      class="c_lp_image_text_tabs__content"
      :class="tabs[activeTabIndex].alignment ? 'c_lp_image_text_tabs__content--' + tabs[activeTabIndex].alignment : ''"
    >
      <MediaImage
        class="c_lp_image_text_tabs__content__image"
        :sources="formatImages(tabs[activeTabIndex].image[0])"
        :alt="tabs[activeTabIndex].title"
        v-if="tabs[activeTabIndex].image && tabs[activeTabIndex].image.length"
      />
      <div class="c_text c_lp_image_text_tabs__content__text" v-html="tabs[activeTabIndex].text"></div>
      <LinkField
        v-if="buttons && buttons[activeTabIndex] && parseLinkField(buttons[activeTabIndex], 'superTable').valid"
        :super-table-field="buttons[activeTabIndex]"
      />
    </div>
  </div>
</template>

<script>
import { parseLinkField, log } from 'JS/global.js';
import Tabs from 'Components/tabs/Tabs.vue';
import LinkField from 'Components/link_field/LinkField.vue';
import MediaImage from 'Components/image/MediaImage.vue';
export default {
  components: {
    LinkField,
    MediaImage,
    Tabs,
  },
  data() {
    return {
      activeTabIndex: 0,
    };
  },
  props: {
    tabs: Array,
    imageFields: Array,
    buttons: Array,
  },
  methods: {
    parseLinkField: parseLinkField,
    setTab: function(tab, tabIdentifier) {
      this.activeTabIndex = tabIdentifier;
    },
    formatImages: function(image) {
      let fieldSources = [];
      for (let f = 0; f < this.imageFields.length; f++) {
        fieldSources.push({ srcset: image[this.imageFields[f]].srcsetWebp, type: 'webp' });
        fieldSources.push({ srcset: image[this.imageFields[f]].srcset });
      }

      return fieldSources;
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss">
.c_lp_image_text_tabs {
  $self: &;
  @at-root #{$self}__content {
    $content: &;
    display: grid;
    grid-template-rows: auto;
    grid-gap: px_to_rem(30);

    @at-root .app--isEdge15orDown & {
      display: flex;
      flex-flow: column nowrap;
    }
    @include mq($mq_image_text_tabs_1) {
      grid-template-columns: px_to_rem(150) auto;
      @at-root .app--isEdge15orDown & {
        flex-flow: row wrap;
        & > * {
          flex: 0 1 50%;
        }
      }
      @at-root #{&}--textImage {
        grid-template-columns: auto px_to_rem(150);
      }
    }
    @include mq($mq_sm_to_md) {
      grid-template-columns: 3fr 7fr;
      @at-root #{&}--textImage {
        grid-template-columns: 7fr 3fr;
      }
    }
    @at-root #{&}__image {
      @include mq($mq_image_text_tabs_1) {
        @at-root #{$content}--textImage #{&} {
          grid-column: 2;
        }
      }
    }
    @at-root #{&}__text {
      $text: &;
      grid-row: 2;
      --text-fz: 1rem;
      @include mq($mq_image_text_tabs_1) {
        grid-column: 1/3;
        grid-row: 1;
        @at-root #{$content}__image + #{&} {
          grid-column: 2;
        }
        @at-root #{$content}--textImage {
          #{$content}__image + #{$text} {
            grid-column: 1;
          }
        }
      }
    }
  }
}
</style>
